function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Circle, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
  id: "icon-nothing_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  rx: 10
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "icon-nothing_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#icon-nothing_svg__a"
})), /*#__PURE__*/React.createElement(Use, {
  fill: "#00245A",
  xlinkHref: "#icon-nothing_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#17BF88",
  strokeWidth: 1.5,
  mask: "url(#icon-nothing_svg__b)"
}, /*#__PURE__*/React.createElement(G, {
  transform: "rotate(-45 27.778 1.222)"
}, /*#__PURE__*/React.createElement(Circle, {
  cx: 9,
  cy: 9,
  r: 9
}), /*#__PURE__*/React.createElement(Path, {
  d: "M0 9h18"
}))));

function SvgIconNothing(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _ref, _ref2);
}

export default SvgIconNothing;